<template>
  <form novalidate class="md-layout" @submit.prevent="validateUser">
    <div class="md-layout-item md-elevation-0">

      <md-card class="md-elevation-0 m-5">
        <md-card-header class="md-layout md-alignment-center-left justify header-bg">
          Declaración Jurada de Inversionista Institucional

        </md-card-header>
        <md-card-content class="md-layout">
          <p align="justify">
            Inversionista Institucional: Personas naturales que cuentan con un patrimonio superior a S/. 4 millones y un portafolio de inversiones en valores igual o superior a S/. 2 millones.
          </p>
          <p align="justify">
            Ante cualquier duda, comuníquese con su promotor.
          </p>
        </md-card-content> 
      </md-card>            

      <md-card class="md-elevation-0 m-5">
        <md-card-header class="md-layout md-alignment-center-left justify cursiva">
          <p align="justify">
            Declaración Jurada – Inversionista Institucional
            <br>
            <br>
            Declaro bajo juramento lo siguiente: 
          </p>
        </md-card-header>
        <md-card-content class="md-layout cursiva">
          <p align="justify">
            (1)	Que, a la fecha de suscripción del presente documento, califico como Inversionista Institucional, en los términos de lo establecido en el artículo 3 del Reglamento del Mercado de Inversionistas y, por lo tanto, puedo suscribir cuotas de participación en cualquier Fondo Mutuo de Inversión en Valores que sea administrado por Faro Capital SAF S.A.
          </p>
          <p align="justify">
            (2)	Tengo conocimiento de las características y regulación aplicable a los fondos mutuos dirigidos exclusivamente a inversionistas institucionales, así como de las condiciones de la colocación de cuotas del fondo.     
          </p>
          <p align="justify">
            En tal sentido, por medio de la presente me comprometo a informar a Faro Capital SAF S.A., cualquier variación que pudiera surgir respecto de mi condición de Inversionista Institucional. Finalmente declaro conocer que de resultar falsa la declaración efectuada, me encontraré sujeto(a) a las responsabilidades administrativas y penales correspondientes.
          </p>
          <p align="justify">
            “Infórmese de las características esenciales de la inversión en los Fondos Mutuos administrados por Faro Capital SAF S.A., las que se encuentran contenidas en el prospecto simplificado y reglamento de participación."            
          </p>


        </md-card-content> 
      </md-card>       

      <md-card class="md-elevation-0 m-5" :class="getValidationClass('declaracioninversionistainstitucional')">
        <md-card-header class="md-layout md-alignment-center-left justify">
          Suscribe usted la presente Declaración Jurada de Inversionista Institucional *
        </md-card-header>
        <md-card-content class="md-layout">
            <p align="justify">
                En caso requiera mayor información sobre este punto, por favor, comuníquese con su promotor.
            </p>
            <div>
              <md-checkbox v-model="form.declaracioninversionistainstitucional" value="Si">Sí, es conforme</md-checkbox>
            </div>

            <div class="radioform" :class="getValidationClass('declaracioninversionistainstitucional')">
              <span class="md-error" v-if="!$v.form.declaracioninversionistainstitucional.required">Esta respuesta es obligatoria.</span>
            </div>              

        </md-card-content> 
      </md-card>           

      <Botonera :form="form" :back="back" :Bottontitle="'Siguiente'"/>                 
      
    </div>
  </form>
</template>

<style>

</style>

<script>
import { validationMixin } from 'vuelidate'
import {
  required
} from 'vuelidate/lib/validators'

export default {
  mixins: [validationMixin],
  name: 'Item12',
  data: () => ({
    form:{
    }
  }),
  props: ["title", "data"],
  mounted: function(){
    this.form = this.$store.state.item.item12

  },  
  validations: {
    form: {
      declaracioninversionistainstitucional: {required,},
    },
  },
  methods: {
    back () {
      this.$emit('setBack', {id: this.$options.name})
      this.form = this.$store.state.item.item12
    },    
    validateUser () {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        var index = "0";
        if(this.data.name == "Participe"){
          if(this.$store.state.item.item9.titularidad == "Individual"){
            
            if(this.$store.state.item.item10.personanatutalinstitucional == "Si"){
              index= "14";     
            }else{
              index= "13";
            }

          }else{
            if(this.$store.state.item.item10.personanatutalinstitucional == "Si"){
              index= "14";     
            }else{
              index= "13";
            }
          }
        }else{
          if(this.$store.state.item.item10.personanatutalinstitucional == "Si"){
            index= "16";     
          }else{
            index= "13";
          }
        }
        this.$emit('setSaveForm', {id:"12", form: this.form, index: index});

      }

    },
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },        
  },
  components:{
    "Botonera": () => import('./Botonera.vue')
  }          
}
</script>
